<div [class.timesheet-grid]="last" class="timesheet-day-block" [ngStyle]="{ 'height.px': height }">
  @if (show) {
    <div>
      <span class="timesheet-day-block__title">{{ date | localeDate: 'weekdayMedium' : { year: 'numeric' } }}</span>
      <div class="timesheet-totals">
        <div class="timesheet-totals__time">
          <small>{{ approvedTotal.hours | localeDuration: 'digital' }}</small>
        </div>
        @if (showSalary) {
          <div
            [sbTooltipPlacement]="'top'"
            class="timesheet-totals__salary"
            [sbTooltip]="'Worked - Scheduled' | translate"
          >
            @if (scheduleDiff != 0) {
              <small
                ><span>{{ scheduleDiff | localeDuration: 'digital' }}</span></small
              >
            }
          </div>
        }
      </div>
    </div>
  }
</div>
